import { AuthenticatorService, IAuthenticatorService } from '../authenticator-service';
import { AuthenticateMode, IAuthenticatePartialComponent } from '../models';

export class AuthenticatePartialComponent implements IAuthenticatePartialComponent {
  protected rootElement: HTMLElement;
  protected authenticator: IAuthenticatorService;

  constructor(rootElement: string | HTMLElement, authenticator?: IAuthenticatorService) {
    if (typeof rootElement === 'string') {
      this.rootElement = document.querySelector(rootElement);
    } else {
      this.rootElement = rootElement;
    }

    this.authenticator = authenticator || new AuthenticatorService();
  }

  public show(...args: any[]): void {
    if (this.rootElement === null) {
      return;
    }

    this.rootElement.style.display = 'block';
  }

  public hide(): void {
    if (this.rootElement === null) {
      return;
    }

    this.rootElement.style.display = 'none';
  }

  public toggle(...args: any[]): void {
    if (this.rootElement === null) {
      return;
    }

    const currentState = this.rootElement.style.display;
    if (currentState === 'none') {
      this.show(args);
    } else {
      this.hide();
    }
  }

  public querySelector(selector: string): HTMLElement {
    return this.rootElement.querySelector(selector);
  }

  public onSubmit(nextMode?: AuthenticateMode, ...args: any[]): void {
    console.log('Not implemented method.');
  }
}
